<!--隐私协议-->
<template>
    <div class="about">
        <div class="about-back">
            <img src="@/assets/about_background.png" width="100%">
        </div>
        <div class="main">
            <div class="main-title">
                <i class="main-title-dot"></i>
                公司简介
            </div>
            <div class="main-text">
                    <p><strong>江苏爱驿站信息科技有限公司</strong>成立2014年，作为全国知名的连锁互联网婚恋服务品牌，拥有百万级优质单身会员库。公司创新构建 “线下门店实名认证审核 + 线上智能软件交互 + 专属门店红娘免费服务” 的三维联动高效婚配模式，深度整合真实婚恋资源，为单身男女打造贯穿 “信息验证 - 智能匹配 - 精准服务” 全链条的真实、高效一站式婚恋服务体系，致力于让每一份真心都能遇见对的人。</p>
            </div>

            <div class="main-title">
                <i class="main-title-dot"></i>
                联系我们
            </div>
            <div class="main-text">
                <div class="main-text-item">
                    <div class="item-title">公众号</div> <strong class="item-value">父母牵缘官方</strong>
                </div>

                <div class="main-text-item">
                    <div class="item-title">小程序</div> <strong class="item-value">父母牵缘婚恋</strong>
                </div>

                <div class="main-text-item">
                    <div class="item-title">客服电话</div> <strong class="item-value">400 6622 521</strong>
                </div>
                
                <div class="main-text-item">
                    <div class="item-title">客服邮箱</div> <strong class="item-value">kefu@aiyizhan.com</strong>
                </div>
            </div>

            <div class="main-title">
                <i class="main-title-dot"></i>
                相关许可证
            </div>
            <div class="certificate">
                <div class="certificate-img">
                    <img src="/certificate/certificate6.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate5.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate3.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate7.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate8.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate9.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate4.png" width="100%" alt="爱驿站">
                </div>

                <div class="certificate-img">
                    <img src="/certificate/certificate10.png" width="100%" alt="爱驿站">
                </div>
            </div>
            

        </div>

    </div>

</template>

<script setup>

</script>

<style lang="scss">
.about{
    width: 100%;
    padding-bottom: 40px;
    .about-back{
        width: 100%;
        position: relative;
        z-index: 0;
        img{
            z-index: 0;
        }
        // min-height: 280px;
        // justify-content: center; /* 水平居中 */
        // align-items: center;
        // background-image: url('~@/assets/about_background.png');
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
    }
    .main{
        z-index: 2;
        position: relative;
        width: 95%;
        min-height: 1000px;
        margin: auto;
        background-color: #ffffff;
        margin-top: -40px;
        border-radius: 19px;
        padding-bottom: 35px;
        .main-title{
            display: flex;
            padding-top: 37px;
            margin-left: 24px;
            font-size: 17px;
            height: 17px;
            line-height: 17px;
            font-weight: 600;
            .main-title-dot{
                width: 5px;
                height: 16px;
                background-color: #FE405F;
                border-radius: 3px;
                margin-right: 11px;
            }
        }
        .main-text{
            margin: 37px 24px 0 24px;
            text-align: left;
            font-size: 15px;
            line-height: 30px;
            color: #222222;
            text-indent: 2em;
            .main-text-item{
                text-indent: 0em;
                display: flex;
                color: #555555;
                .item-title{
                    width: 90px;
                }
                .item-value{
                    color: #222222;
                }
            }
        }
        .certificate{
            margin-top: 40px;
            .certificate-img{
                width: 100%;
                margin-top: 15px;
            }
        }

    }

}

</style>
